import { ClipboardList, Calculator, Mail } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Pick your services",
    text: "Browse 17 real garden projects — from jet washing to full patio installs.",
  },
  {
    n: "02",
    icon: Calculator,
    title: "Stay under £2,000",
    text: "A live budget tracker keeps you in control. Submission locks at the cap.",
  },
  {
    n: "03",
    icon: Mail,
    title: "We get in touch",
    text: "Your wishlist lands straight in our inbox. We confirm dates and quote.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="border-b-2 border-black bg-[#F4F4F5]"
    >
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-12">
          <div className="md:col-span-4">
            <div className="mb-4 inline-block border-2 border-black bg-white px-2 py-1 font-display text-[10px] font-bold uppercase tracking-[0.25em]">
              The Process
            </div>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tighter text-black sm:text-5xl">
              Three steps.
              <br />
              <span className="text-[#9D4CDD]">No surprises.</span>
            </h2>
            <p className="mt-4 max-w-sm font-display text-base text-black/70">
              Designed for homeowners across Ayrshire who want a clear,
              fixed-budget garden transformation.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-0 border-2 border-black bg-white md:col-span-8 md:grid-cols-3">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  data-testid={`how-step-${i + 1}`}
                  className={`flex flex-col gap-5 p-6 md:p-8 ${
                    i < STEPS.length - 1
                      ? "border-b-2 border-black md:border-b-0 md:border-r-2"
                      : ""
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-display text-5xl font-black text-black/10">
                      {s.n}
                    </span>
                    <div className="border-2 border-black bg-[#9D4CDD] p-2">
                      <Icon
                        className="h-5 w-5 text-white"
                        strokeWidth={2.5}
                      />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-bold tracking-tight text-black">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-black/70">
                      {s.text}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
